module.exports = __webpack_public_path__ + "static/media/bg-movie.8bf89ece.jpg";